import { ViewType } from '.';

export type IViewType = keyof typeof ViewType | null;

export interface IAgentPerformanceParams {
  viewType: IViewType;
  agentId?: string;
  teamLeadId?: string;
  pageNo?: string;
  pageSize?: string;
  filters?: string;
  inputTableSortKey: string;
  inputTableSortOrder: string;
  sortColumnInput?: string;
  sortOrderInput?: string;
  radioOption?: string;
  startDate?: string;
}

export interface IAvailabilityHistoryParams {
  urlParams: IAgentPerformanceParams;
  updateAndNavigate: (params: IAgentPerformanceParams) => void;
}

export const TABLE_DEFAULT_VALUES = {
  pageSize: '50',
  pageNo: '1'
};

export interface IFilters {
  params: IAgentPerformanceParams;
  updateAndNavigate: (params: IAgentPerformanceParams) => void;
}

export interface IMainContent {
  params: IAgentPerformanceParams;
  updateAndNavigate: (params: IAgentPerformanceParams) => void;
  loading?: boolean;
  shouldShowTlModal?: boolean;
}

export interface IAgentAvailabilityData {
  agentAvaibilityData: IAgentAvaibilityDatum[];
  lastRefreshedTimeStamp: string;
  agentNames: IAgentName[];
  tlNames: ITlName[];
}

export interface IAgentAvaibilityDatum {
  loginTimeStampEpoch: number;
  agentName: string;
  agentReferenceId: string;
  tlReferenceId: string;
  hourlyData?: IHourlyData;
  activeDurationInMinutes: number;
  totalDurationInMinutes: number;
  activityStatusTillCurrentTime: string;
  loginStatus: string;
  firstCallTimeStampEpoch: number;
  breakDurationInMinutes: number;
  breakReason: string;
  breakDurationStatus: string;
  ameyoEfficiencyStatus: string;
}

export interface IAvailabilityHistoryData {
  agentName: string;
  agentReferenceId: string;
  tlReferenceId: string;
  historyData: IAgentAvailabilityHistory;
}
export interface IAgentAvailabilityHistory {
  [key: string]: IAgentAvailabilityHistoryParams;
}
export interface IAgentAvailabilityHistoryParams {
  loginTimeStamp: string;
  activeMinutes: number;
  totalMinutes: number;
  loginStatus: string;
  logoutStatus: string;
  logoutTimStamp: string;
  firstCallTimeStamp: string;
  breakDurationInMinutes: number;
}

export enum HourlyDataKeys {
  '08:00:00' = '08:00:00',
  '09:00:00' = '09:00:00',
  '10:00:00' = '10:00:00',
  '11:00:00' = '11:00:00',
  '12:00:00' = '12:00:00',
  '13:00:00' = '13:00:00',
  '14:00:00' = '14:00:00',
  '16:00:00' = '16:00:00',
  '17:00:00' = '17:00:00',
  '18:00:00' = '18:00:00',
  '19:00:00' = '19:00:00',
  '20:00:00' = '20:00:00'
}

export type IHourlyData = {
  [key in HourlyDataKeys]: IHourlyDataParams;
};

export interface IAgentName {
  label: string;
  value: string;
}

export interface ITlName {
  label: string;
  value: string;
}

export interface IAgentAvailabilityState {
  agentAvailabilityData: IAgentAvaibilityDatum[];
  loading: boolean;
  error: string;
  lastUpdatedAt: string;
  radioOption: string;
  historyLoading: boolean;
  agentAvailablityHistoryData: IAvailabilityHistoryData[];
  tlDetails: {
    name: string;
    referenceId: string;
  }[];
  reporteesDetails: {
    name: string;
    referenceId: string;
    tlReferenceId: string;
  }[];
}

export interface IHourlyDataParams {
  minutesWorkedInTheHour: number;
  agentAvailabilityInTheHour: string;
}

export enum AGENT_PERFORMANCE_FILTERS {
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
  LATE_LOGGED_IN = 'LATE_LOGGED_IN',
  LESS_ACTIVE = 'LESS_ACTIVE',
  AWAY = 'AWAY',
  EXCEEDED = 'EXCEEDED',
  CALLS_NOT_DONE = 'CALLS_NOT_DONE',
  LESS_AMEYO_TIME = 'LESS_AMEYO_TIME',
  EARLY_LOGGED_OUT = 'EARLY_LOGGED_OUT'
}

interface FilterCounts {
  NOT_LOGGED_IN: number;
  LATE_LOGGED_IN: number;
  LESS_ACTIVE: number;
  AWAY: number;
  EXCEEDED: number;
  CALLS_NOT_DONE: number;
  LESS_AMEYO_TIME: number;
}
export interface ITableFilters {
  filters: string[];
  isOpen: boolean;
  filterCount: FilterCounts;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleClearAll: () => void;
  handleChipClick: (label: string) => void;
  handleCloseIconClick: (label: string) => void;
  showClearAll: boolean;
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc'
}

export interface IAllCommonCell {
  isLateLogin: boolean;
  isLogoutEarly: boolean;
  loginDate: string;
  logoutDate: string;
  firstCallDate: string;
  breakHoursFormat: string;
  totalMinutes: number;
  activeMinutes: number;
  computeClassNames: string;
  percentage: number;
}

export enum HistoryColDefCell {
  ALL = 'All',
  LOGIN_TIME = 'LoginTime',
  LOGOUT_TIME = 'LogoutTime',
  FIRST_CALL_TIME = 'FirstCall',
  BREAK_HRS = 'BreakHrs',
  ACTIVE_HRS = 'ActiveHrs'
}
